import { MirageApplicationTypes } from "../mirage/core/IMirageApplications";
export class PrePublicPortalWlConstants {
    public static get AppName(): typeof MirageApplicationTypes.prePublicPortalWestLindsay {
        return MirageApplicationTypes.prePublicPortalWestLindsay;
    }

    public static get CustomFeeContactMessage(): string {
        return "Please call 01427 676676 to speak to the Planning team";
    }
    public static get DevelopmentTypesBuiltInConfiguration() {
        return [
            {
                name: "Build new dwellings",
                scales: [
                    {
                        name: "New Build",
                        serviceLevels: [
                            {
                                name: "Stage 1 (Principle)",
                            },
                            {
                                name: "Stage 2 (Detailed Design and Layout)",
                            },
                        ],
                    },
                    {
                        name: "Conversion (e.g. house into flats)",
                        serviceLevels: [
                            {
                                name: "Stage 1 (Principle)",
                            },
                            {
                                name: "Stage 2 (Detailed Design and Layout)",
                            },
                        ],
                    },
                ],
            },
            {
                name: "Make alterations or extensions to an existing house",
                scales: [
                    {
                        name: "Extension (e.g. conservatory)",
                        serviceLevels: [
                            {
                                name: "Stage 1 (Principle)",
                            },
                            {
                                name: "Stage 2 (Detailed Design and Layout)",
                            },
                        ],
                    },
                    {
                        name: "Outbuilding (e.g. garage, shed)",
                        serviceLevels: [
                            {
                                name: "Stage 1 (Principle)",
                            },
                            {
                                name: "Stage 2 (Detailed Design and Layout)",
                            },
                        ],
                    },
                    {
                        name: "Other (e.g. solar panels)",
                        serviceLevels: [
                            {
                                name: "Stage 1 (Principle)",
                            },
                            {
                                name: "Stage 2 (Detailed Design and Layout)",
                            },
                        ],
                    },
                ],
            },
            {
                name: "Retail/office/industrial development",
                scales: [
                    {
                        name: "Extension",
                        serviceLevels: [
                            {
                                name: "Stage 1 (Principle)",
                            },
                            {
                                name: "Stage 2 (Detailed Design and Layout)",
                            },
                        ],
                    },
                    {
                        name: "New Build",
                        serviceLevels: [
                            {
                                name: "Stage 1 (Principle)",
                            },
                            {
                                name: "Stage 2 (Detailed Design and Layout)",
                            },
                        ],
                    },
                    {
                        name: "Change of use (e.g. residential to retail)",
                        serviceLevels: [
                            {
                                name: "Stage 1 (Principle)",
                            },
                            {
                                name: "Stage 2 (Detailed Design and Layout)",
                            },
                        ],
                    },
                    {
                        name: "Alterations (e.g. shop fronts, pv panels, fences)",
                        serviceLevels: [
                            {
                                name: "Stage 1 (Principle)",
                            },
                            {
                                name: "Stage 2 (Detailed Design and Layout)",
                            },
                        ],
                    },
                ],
            },
            {
                name: "Any other type of development (e.g. solar panels)",
                scales: [
                    {
                        name: "Variation or removal of a condition",
                        serviceLevels: [
                            {
                                name: "Stage 1 (Principle)",
                            },
                            {
                                name: "Stage 2 (Detailed Design and Layout)",
                            },
                        ],
                    },
                    {
                        name: "Advertisements",
                        serviceLevels: [
                            {
                                name: "Stage 1 (Principle)",
                            },
                            {
                                name: "Stage 2 (Detailed Design and Layout)",
                            },
                        ],
                    },
                    {
                        name: "Non-householder listed building consent",
                        serviceLevels: [
                            {
                                name: "Stage 1 (Principle)",
                            },
                            {
                                name: "Stage 2 (Detailed Design and Layout)",
                            },
                        ],
                    },
                    {
                        name: "Other",
                        serviceLevels: [
                            {
                                name: "Stage 1 (Principle)",
                            },
                            {
                                name: "Stage 2 (Detailed Design and Layout)",
                            },
                        ],
                    },
                ],
            },
        ];
    }
}
